import styled from 'styled-components';
import { device } from '../../device';

export const StyledAbout = styled.section`


`;

export const Heading = styled.h1`
    font-size:1rem;
    color: #8B8B8B;
    text-align: left;
    padding:0;
    margin:0;
    border-bottom:1px solid #E2E2E2;
    padding-bottom:20px; 
    padding-top:20px;
    margin-bottom:30px;
`;
